export const FORM = "form";
export const FORM_INITIAL = "formInitial";
export const MEDIA_INITIAL = "mediaInitial";
export const FORM_QUERY = "formQuery";
export const DONATION = "donation";
export const DONATION_INITIAL = "donationInitial";
export const DONATION_QUERY = "donationQuery";
export const GIFT_DONE = "giftDone";
export const PREVIEW = "preview";

export function nextCreateCommentStep(context, steps, noDonations) {
  switch (context) {
    case MEDIA_INITIAL:
    case FORM_INITIAL:
    case FORM_QUERY:
    case FORM:
      // Back from the preview, the gift question has already been answered.
      if (!(noDonations || steps.donation || steps.preview)) {
        return DONATION_QUERY;
      }

      return PREVIEW;

    case DONATION_INITIAL:
      return FORM_QUERY;

    case DONATION_QUERY:
      return DONATION;

    case DONATION:
      return steps.form ? PREVIEW : FORM_QUERY;

    default:
      return FORM;
  }
}
